import React, { useCallback } from 'react';

import { useModalStore } from 'bdvp-common/src/hooks/store';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import useSearchSort from '../hooks/store/useSearchSort';
import Component from '../components/SortModal';

const { SEARCH_SORT_MODAL_NAME } = modalConstants;

const SortModal = () => {

    const {
        searchSortOptions,
        searchSortSelectedOption,
        applySearchSort,
    } = useSearchSort();
    const { modalHide } = useModalStore();

    const hideSortModal = useCallback(() => {

        modalHide(SEARCH_SORT_MODAL_NAME);

    }, [modalHide]);

    return (
        <Component
            options={searchSortOptions}
            selected={searchSortSelectedOption}
            hideSortModal={hideSortModal}
            applySearchSort={applySearchSort}
        />
    );

};

export default SortModal;
